import { SpecialFormGroup, SpecialFormControl } from "@utilities/SpecialForms";
import { CustomerModel } from "@models/configuration/customer.model";
import {
  Validators,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  FormControl,
} from "@angular/forms";
import { isNullOrUndefined } from "util";

export class Validations {
  public static addValidations(
    form: SpecialFormGroup,
    customers: CustomerModel[],
    key: string
  ): void {
    const emailControl = <SpecialFormControl>form.get("email");

    let myCustomers: CustomerModel[] = [];
    if (key) {
      myCustomers = customers.filter((i) => i.id !== parseInt(key));
    } else {
      myCustomers = customers;
    }
    console.log("LLAMA VALIDACIONES", myCustomers);

    if (emailControl && myCustomers && customers.length > 0) {
      emailControl.setValidators([
        Validators.email,
        //this.repeatedEmailAreaValidator(myCustomers),
      ]);
    } else {
      emailControl.setValidators([
        Validators.email,
        //this.repeatedEmailAreaValidator(myCustomers),
      ]);
    }
  }

  // Validador de nombre repetido
  private static repeatedNameValidator(list: CustomerModel[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const emailVerify = (control.value as string).trim().toLowerCase();
        console.log(list);
        const emailList = list
          .filter((i) => !isNullOrUndefined(i.email))
          .map((i) => i.email.toLowerCase());
        const result = emailList.includes(emailVerify);
        console.log(emailVerify);
        console.log(emailList);
        console.log(result);
        return result ? { repeatedName: "Email repetido" } : null;
      } catch {
        const emailVerify = null;
        const emailList = list
          .filter((i) => !isNullOrUndefined(i.email))
          .map((i) => i.email.toLowerCase());
        const result = emailList.includes(emailVerify);
        return result ? { repeatedName: "Email repetido" } : null;
      }
    };
  }

  public static repeatedEmailAreaValidator(
    control: AbstractControl,
    list: CustomerModel[],
    form?: CustomerModel
  ): ValidatorFn {
    console.log(form);
    /* var result: any;
    if (form.name && form.idArea) {
      result = this.validationEmailArea(
        form.name,
        form.idArea.toString(),
        list
      );
    } else {
      result = false;
    }
    console.log(result); */
    return (control: AbstractControl): ValidationErrors | null => {
      let email = form.name ? form.name : null;
      let idArea = form.idArea ? form.idArea.toString() : null;
      console.log(email, idArea);
      const emailVerify = (email as string).trim().toLowerCase();
      const idAreaVerify = (idArea as string).trim().toLowerCase();
      let newList = list.map((i) => {
        return {
          email: i.email ? i.email.toString() : null,
          idArea: i.email ? i.idArea.toString() : null,
        };
      });
      const emailList = newList
        .filter(
          (i) => !isNullOrUndefined(i.email) && !isNullOrUndefined(i.idArea)
        )
        .map((i) => i.email.toLowerCase() + i.idArea.toLowerCase());

      //console.log(emailList);
      const emailAreaFind =
        emailVerify.toLowerCase() + idAreaVerify.toLowerCase();
      //console.log(emailAreaFind);
      var result: any;
      result = emailList.includes(emailAreaFind);
      //console.log(result);
      return result ? { repeatedName: "Email repetido" } : null;
    };
  }

  public static validationEmailArea(
    email: string,
    idArea: string,
    list: CustomerModel[]
  ): any {
    //console.log(email, idArea);
    email = email ? email : null;
    idArea = idArea ? idArea.toString() : null;
    var result: boolean = false;
    if(email && idArea){
      const emailVerify = (email as string).trim().toLowerCase();
      const idAreaVerify = (idArea as string).trim().toLowerCase();
      let newList = list.map((i) => {
        return {
          email: i.email ? i.email.toString() : null,
          idArea: i.email ? i.idArea.toString() : null,
        };
      });
      const emailList = newList
        .filter(
          (i) => !isNullOrUndefined(i.email) && !isNullOrUndefined(i.idArea)
        )
        .map((i) => i.email.toLowerCase() + i.idArea.toLowerCase());
  
      //console.log(emailList);
      const emailAreaFind =
        emailVerify.toLowerCase() + idAreaVerify.toLowerCase();
      //console.log(emailAreaFind);
      result = emailList.includes(emailAreaFind);
      //console.log(result);
    }

    return result;
  }

  public static addValidationsAutoComplete(
    control: FormControl,
    message: any
  ): void {
    console.log(control);

    if (control) {
      control.setValidators([this.validatorsAutoComplete(message)]);
    }
  }

  private static validatorsAutoComplete(message: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        return message ? message : null;
      } catch {
        return message ? message : null;
      }
    };
  }
}
